import { Activity } from '../../api/model-service/model-service';
import { FormikProps } from '../Formik';

export function resetInput(name: string, formikProps: FormikProps<Activity>): void {
    formikProps.setFieldValue(name, null);
    formikProps.setFieldTouched(name, false);
}
